import React, { useState, useRef } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "./PasswordReset.css";

const ResetPassword = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(new Array(6).fill(""));
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const inputRefs = useRef([]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") setEmail(value);
    if (name === "newPassword") setNewPassword(value);
  };

  // OTP Input Handling
  const handleChange = (index, e) => {
    const value = e.target.value;
    if (!/^[0-9]?$/.test(value)) return; // Allow only numbers

    let newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus(); // Move to next input
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus(); // Move to previous input
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text").slice(0, 6).replace(/\D/g, "");
    if (pasteData.length === 6) {
      setOtp([...pasteData]);
      inputRefs.current[5].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (otp.includes("")) {
      toast.error("❌ Please enter a 6-digit OTP", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      return;
    }

    setLoading(true);
    const otpCode = otp.join("");

    try {
      const response = await fetch("https://riymay.com/api/v1/user/reset/password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, otp: otpCode, newpassword: newPassword }),
      });

      const data = await response.json();

      if (!response.ok) {
        toast.error(data.message || "❌ Failed to reset password. Please try again.", {
          position: "top-right",
          autoClose: 3000,
          theme: "colored",
        });
        return;
      }

      toast.success("✅ Password reset successfully!", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
      navigate("/login");
    } catch (error) {
      toast.error("❌ Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reset-page">
      <div className="login-box">
        <form onSubmit={handleSubmit} className="login-form-container">
          <h2 className="reset-heading">Reset Password</h2>

          <div className="login-form-group">
            <input
              type="email"
              id="email"
              name="email"
              className="login-input"
              placeholder="Enter your email"
              value={email}
              onChange={handleInputChange}
              required
            />
          </div>

          {/* OTP Input Boxes */}
         

          <div className="login-form-group">
            <input
              type="password"
              id="newPassword"
              name="newPassword"
              className="login-input"
              placeholder="Enter your new password"
              value={newPassword}
              onChange={handleInputChange}
              required
            />
          </div>
          <div className="otp-input-container" onPaste={handlePaste}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                maxLength="1"
                className="otp-input"
                value={digit}
                onChange={(e) => handleChange(index, e)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                ref={(el) => (inputRefs.current[index] = el)}
              />
            ))}
          </div>

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
